<template>
	<div class="mb_20">
		<p class="mb_10">{{ $t('rtr_pay-invoice.title1') }}</p>
		<input
			type="email"
			v-model="params.email"
			:placeholder="$t('rtr_pay-invoice.input1')"
		/>
	</div>
	<div class="mb_20">
		<p class="mb_10">{{ $t('rtr_pay-invoice.title2') }}</p>
		<input
			type="text"
			v-model="params.title"
			:placeholder="$t('rtr_pay-invoice.input2')"
		/>
	</div>
	<div class="mb_20">
		<p class="mb_10">{{ this.selectedAccountInfo?.asset_code }}</p>
		<input type="text" v-model="params.amount" placeholder="0" />
	</div>
	<!--	<div class="d_flex">-->
	<!--		<div class="mb_20 date mr_10">-->
	<!--			<p class="mb_10">{{ $t('rtr_pay-invoice.title4') }}</p>-->
	<!--			<date-picker-->
	<!--				is-required-->
	<!--				v-model="params.endDate"-->
	<!--				:model-config="{ type: 'string' }"-->
	<!--				:locale="$store.state.common.locale"-->
	<!--			>-->
	<!--				<template v-slot="{ inputValue, inputEvents }">-->
	<!--					<label class="calendar_area">-->
	<!--						<input-->
	<!--							class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"-->
	<!--							:value="inputValue"-->
	<!--							v-on="inputEvents"-->
	<!--						/>-->
	<!--					</label>-->
	<!--				</template>-->
	<!--			</date-picker>-->
	<!--		</div>-->
	<!--	</div>-->
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'invoice',
	emits: ['change'],
	props: {
		assetSeq: {
			default: null,
			type: Number,
		},
	},
	data() {
		return {
			params: {
				email: '',
				title: '',
				amount: '',
				endDate: '',
			},
			selectedAssetSeq: null,
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		selectedAccountInfo() {
			return this.accounts.find(account => {
				return account.asset_seq === this.assetSeq;
			});
		},
	},
	watch: {
		params: {
			deep: true,
			handler() {
				this.$emit('change', this.params);
			},
		},
	},
	methods: {
		initForm() {
			this.params = {
				email: '',
				title: '',
				amount: '',
				endDate: '',
			};
		},
	},
};
</script>
